import {
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BFormFile,
  BFormTextarea,
} from "bootstrap-vue";
import InputGroup from "@@/core/components/product/shared/InputGroup/InputGroup";
import Discount from "@@/core/components/product/shared/Discount/Discount";
import ProductImages from "@@/core/components/product/ProductImages/ProductImages";
import { Treeselect } from "@riophae/vue-treeselect";
import Images from "@@/core/components/product/Images/Images.vue";
export default {
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BFormFile,
    Treeselect,
    InputGroup,
    Discount,
    ProductImages,
    BFormTextarea,
    Images,
  },
  data() {
    return {
      mode: "create",
      id: null,
      statusOptions: [
        {
          id: "available",
          label: "موجود",
        },
        {
          id: "soon",
          label: "بزودی",
        },
        {
          id: "out_of_stock",
          label: "ناموجود",
        },
        {
          id: "draft",
          label: "پیش نویس",
        },
      ],
      discountOptions: [
        {
          id: "",
          label: "ندارد",
        },
        {
          id: "flat",
          label: "قیمت ثابت",
        },
        {
          id: "percentage",
          label: "درصد",
        },
      ],
      product: {
        title: "",
        price: 0,
        purchase_price: 0,
        discount_type: "",
        discount: "",
        discount_until: "",
        short_description: null,
        status: "available",
        main_image: null,
        images: [],
        deleted_images: [],
        meta_description: null,
        meta_title: null,
        deleted_images: [],
      },
      deletedList: [],
    };
  },
  created() {
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      this.mode = "edit";
      this.loadData(this.$route.params.id);
    }
  },
  mounted() {},
  methods: {
    addToDeletedList(id) {
      this.product.images = this.product.images.filter(
        (item) => item.key != id
      );
      this.deletedList.push(id);
    },
    async loadData(id) {
      await this.$axios
        .get(`admin/products/${id}`)
        .then((res) => {
          let data = res.data.data.product;
          this.productDataAssign(data);
        })
        .catch((error) => {
          this.$root.notify(error);
        });
    },
    productDataAssign(data) {
      this.product = {
        title: data.title ?? "",
        price: data.price ?? 0,
        purchase_price: data.purchase_price ?? 0,
        discount_type: data.discount_type ?? "",
        discount: data.discount ?? "",
        discount_until: data.discount_until ?? "",
        short_description: data.short_description ?? "",
        status: data.status ?? "available",
        meta_description: data.meta_description ?? "",
        meta_title: data.meta_title ?? "",
        main_image: null,
        images: [],
      };
      if (
        data.media_showcase &&
        !this.$root.isEmptyObject(data.media_showcase)
      ) {
        if (data.media && data.media.length) {
          this.product.images = data.media.map((img) => {
            return {
              key: img.id,
              old: true,
              url: img.original_url,
            };
          });
        }
        if (
          data.media_showcase.main_image &&
          data.media_showcase.main_image.length
        ) {
          this.product.main_image = data.media_showcase.main_image[0]
            ? data.media_showcase.main_image[0]
            : null;
        }
      }
    },
    discountChanged(val) {
      if (val > 100) {
        this.product.discount = 100;
      } else if (val < 1) {
        this.product.discount = 1;
      }
    },
    changeDiscountOption(e) {
      if (e.id == "") {
        this.product.discount = null;
        this.product.discount_type = null;
        this.product.discount_until = null;
      } else {
        return;
      }
    },
    async submitHandler() {
      let formData = new FormData();
      for (const key in this.product) {
        if (key == "images") {
          let i = 0;
          this.product[key].forEach(async (img, index) => {
            if (!img.old) {
              formData.append(`images[${i}]`, img.file);
              i++;
            }
          });
        } else if (key == "main_image") {
          if (this.product.main_image && !this.product.main_image.id) {
            formData.append(key, this.product[key]);
          }
        } 
        // else if (key == "price" || key == "purchase_price") {
        //   formData.append(
        //     key,
        //     this.product[key] ? this.product[key].replace(",", "") : 0
        //   );
        // } 
        else {
          formData.append(key, this.product[key]);
        }
      }
      if (this.deletedList.length) {
        formData.append("deleted_images", this.deletedList.toString());
      }
      // deleted_images
      if (this.mode == "edit") {
        formData.append("_method", "PUT");
      }

      if (this.mode == "create") {
        await this.$axios
          .post(`admin/products`, formData)
          .then((res) => {
            this.$root.notify(res.data.message, "success");
            this.$router.push("/admin/products");
          })
          .catch((error) => {
            this.$root.notify(error);
          });
      } else {
        await this.$axios
          .post(`admin/products/${this.id}`, formData)
          .then((res) => {
            this.$root.notify(res.data.message, "success");
            this.$router.push("/admin/products");
          })
          .catch((error) => {
            this.$root.notify(error);
          });
      }
    },
    filterInput(num) {
      this.product[num] = this.$options.filters.price(this.product[num]);
    },
    filterDigits(event) {
      if (isNaN(event.key) && event.key !== "Backspace") {
        event.preventDefault();
      }
    },
  },
  computed: {
    getImage() {
      return URL.createObjectURL(this.product.main_image);
    },
  },
};
